/**
 * Dialog liên hệ — mở từ SÁU nút CTA (header, drawer mobile, hero ×2, `#cta` ×2).
 *
 * Tách làm BA mảnh chứ không một câu: email ở giữa được render thành `<a href="mailto:…">`, và
 * một câu liền mạch thì tầng UI phải đi cắt chuỗi để tìm email — cắt theo cái gì thì lại là một
 * nguồn sự thật thứ hai, và nó vỡ ngay khi bản dịch đặt email ở vị trí khác.
 *
 * `close` KHÔNG dùng lại `common.nav.closeMenu` ("Đóng menu"): nhãn đó nói về MENU, và dialog này
 * không phải menu. Một nhãn đúng-gần-đúng đọc lên bằng trình đọc màn hình là một nhãn sai.
 */
export const contact = {
  /** Tiêu đề dialog — render bằng <h2>, và `aria-labelledby` trỏ vào nó. */
  title: 'Liên hệ với chúng tôi',
  before: 'Liên hệ ',
  email: 'support@newera.inc',
  after: ' để biết thêm chi tiết',
  /** Nhãn nút mailto ở footer — KHÁC dialog: nó gửi thẳng mail, không mở dialog. */
  footerCta: 'Liên hệ hỗ trợ',
  close: 'Đóng',
};
